import { useState, useEffect } from 'react';

interface HeroSlide {
  id: number;
  title: string;
  subtitle?: string;
  backgroundImage: string;
}

const slides: HeroSlide[] = [
  {
    id: 1,
    title: 'Redbird Simulator Training',
    backgroundImage: 'https://northamptonairport.com/wp-content/uploads/P1030401-1-1200x675.jpg'
  },
  {
    id: 2,
    title: 'Northampton Airport',
    subtitle: 'The Home of Friendly Flying',
    backgroundImage: 'https://northamptonairport.com/wp-content/uploads/P1030401-1-1200x675.jpg'
  }
];

export function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const currentSlideData = slides[currentSlide];

  return (
    <section className="relative w-full h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-all duration-1000 ease-in-out"
        style={{
          backgroundImage: `url(${currentSlideData.backgroundImage})`,
        }}
      >
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/30" />
      </div>
      
      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-start">
        <div className="text-left text-white px-8 md:px-16 lg:px-24 max-w-4xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-2 drop-shadow-2xl leading-tight">
            {currentSlideData.title}
          </h1>
          {currentSlideData.subtitle && (
            <p className="text-lg md:text-xl lg:text-2xl font-light italic drop-shadow-xl opacity-90">
              {currentSlideData.subtitle}
            </p>
          )}
        </div>
      </div>
      
      {/* Navigation Dots */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentSlide
                ? 'bg-white'
                : 'bg-white/60 hover:bg-white/80'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}